<div class="qr-scan-dialog">
  <!-- Header -->
  <h2 mat-dialog-title class="dialog-header">
    <mat-icon class="header-icon">qr_code_scanner</mat-icon>
    Simulate a QR Scan
  </h2>

  <!-- Content -->
  <mat-dialog-content class="dialog-content">
    <!-- QR Code Placeholder -->
    <div class="qr-code-container">
      <div class="qr-code-box">
        <mat-icon class="qr-icon">qr_code_2</mat-icon>
        <p class="qr-text">Scan QR Code</p>
      </div>
    </div>

    <!-- Location Dropdown -->
    <div class="location-section">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Select Location</mat-label>
        <mat-select [(ngModel)]="selectedLocation" required [disabled]="loading || locations.length === 0">
          <mat-option *ngIf="loading" disabled>
            <mat-spinner diameter="20"></mat-spinner>
            Loading locations...
          </mat-option>
          <mat-option *ngIf="!loading && locations.length === 0" disabled>
            No locations available
          </mat-option>
          <mat-option *ngFor="let location of locations" [value]="location.name">
            <mat-icon class="location-icon">location_on</mat-icon>
            {{ location.name }}
          </mat-option>
        </mat-select>
        <mat-icon matPrefix class="prefix-icon">place</mat-icon>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <!-- Actions -->
  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button (click)="onCancel()" class="cancel-btn">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onOpenForm()" 
      [disabled]="!selectedLocation"
      class="open-form-btn">
      <mat-icon>lock_open</mat-icon>
      Open Form
    </button>
  </mat-dialog-actions>
</div>
